module.exports = __webpack_public_path__ + "media/images/web/home/index/ease_to_use-6a2faaa6c53666e114d691f417d1b8d6.jpg";